module.exports = __webpack_public_path__ + "img/icon-select-no-permission.f939fa73.svg";